import React from 'react';
import ErrorFallback from '../error-fallback';

// App-level error boundary. Without this, a render-time throw anywhere in the
// tree unmounts the whole React root (React 19) and the webview goes blank
// white. This keeps the app alive and shows a recoverable fallback instead.
export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
		this.resetError = this.resetError.bind(this);
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		// Surface the error for debugging; the boundary itself keeps the UI alive.
		console.error('App ErrorBoundary caught an error:', error, info);
	}

	resetError() {
		this.setState({ hasError: false });
	}

	render() {
		if (this.state.hasError) {
			return <ErrorFallback resetError={this.resetError} />;
		}
		return this.props.children;
	}
}
